var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowUp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 14,
    viewBox: "0 0 24 14",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m11.2523.611711-10.967082 11.031789c-.183084.1841-.285218.4287-.285218.683s.102134.4988.285218.6829l.012392.0119c.088756.0895.19559.1608.314004.2095.118414.0488.245932.0739.374797.0739.128869 0 .256379-.0251.374799-.0739.11841-.0487.22525-.12.314-.2095l10.32689-10.38851 10.3227 10.38851c.0887.0895.1956.1608.314.2095.1184.0488.2459.0739.3748.0739s.2564-.0251.3748-.0739c.1184-.0487.2252-.12.314-.2095l.0124-.0119c.1831-.1841.2852-.4286.2852-.6829s-.1021-.4989-.2852-.683l-10.9671-11.031789c-.0965-.097021-.2125-.17426-.341-.227035s-.2669-.079988-.4067-.079988-.2782.027213-.4067.079988-.2445.130014-.341.227035z",
    fill: "#8d8d8d"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/arrowUp.d6392a4d61ad5f53975f7882f6982e48.svg";
export { ForwardRef as ReactComponent };